var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 72,
    viewBox: "0 0 79 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80371 99H38.9928L24.5385 82.7847L38.9928 36.2696L46.3225 59.5271L53.6522 82.7847L38.9928 99H71.4382L48.1678 24.16H30.0742L6.80371 99Z",
    fill: "#5A47AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.428648 35.4584C0.319261 43.9671 2.35959 51.0964 6.5496 56.8466C10.7736 62.6314 16.498 66.7198 23.7228 69.1118L27.3389 56.6506C22.544 55.1477 18.7937 52.646 16.0877 49.1454C13.3818 45.6448 12.0644 41.1327 12.1354 35.6089C12.2311 28.1638 14.7614 22.5859 19.7264 18.8751C24.7254 15.1991 31.2818 13.4132 39.3957 13.5175C47.5092 13.6562 54.0001 15.6269 58.8685 19.4298C63.7713 23.2332 66.1748 28.8574 66.0791 36.3024C66.0081 41.8262 64.5751 46.303 61.7801 49.7328C58.985 53.1627 55.8244 55.2715 50.9925 56.6506L55.6819 69.1116C63.0003 66.9066 66.7802 63.3514 71.1171 57.6766C75.4535 52.0361 77.6765 44.9616 77.7858 36.4529C77.8807 29.0765 76.3292 22.7083 73.1314 17.3484C69.9675 12.0233 65.4986 7.89952 59.7249 4.97716C53.985 2.08957 47.2644 0.596261 39.5631 0.497252C31.8961 0.398685 25.1394 1.71872 19.2928 4.45737C13.4458 7.23032 8.85528 11.2376 5.52116 16.4792C2.22098 21.7556 0.52348 28.082 0.428648 35.4584Z",
    fill: "#5A47AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastlogo);
export default __webpack_public_path__ + "static/media/Lastlogo.dc1aec18ca54505546138b50014f7946.svg";
export { ForwardRef as ReactComponent };